// extracted by mini-css-extract-plugin
module.exports = {"testimonialWrapper":"_1lgs5","preDeliveryInspectionTestimonials":"_39kyG"};